import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { IconCross } from '@alfa-bank/site-icon/cross';

import { ArrowContentContainer as Arrow } from './arrow';
import styles from './styles.css';
import type { IDeps, TArrow } from './models';

export const ArrowContentContainer = createWidget<IDeps, TArrow>({
    IconCross,
    styles,
})(Arrow);
